/**
 * Dynamic Offers Collection Slider Statsig Tester
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModelManager, getOrCreateStatsigManager, buildModelRequestPayload, Logger, syncDebugFlag, getStatsigClient, getSafeStorage, getCartItemsIdsString } from './statsig-manager.js';
const MODEL_KEY = "statsig:test:dyo:collection-slider";
const EXPERIMENT = {
    title: "DyoCollection",
    name: "dyo-minicart-recommender",
    gate: "dyo-minicart-recommender",
    layer: "dyo-minicart-recommender",
};
const DEBUG = true; // Altere para false para desativar logs deste teste
if (!customElements.get("dyo-collection-slider"))
    customElements.define("dyo-collection-slider", class DynamicOffersCollection extends HTMLElement {
        constructor() {
            super();
            this.customerId = this.getAttribute("data-customer-id") || null;
            this.sliderId = this.getAttribute("data-slider-id") || null;
            this.statsigGate = this.getAttribute("data-statsig-gate") || EXPERIMENT.gate;
            this.statsigLayer = this.getAttribute("data-statsig-layer") || EXPERIMENT.layer;
            this.MODEL_KEY = `${this.getAttribute("data-model-key")}` || MODEL_KEY;
            this.maxProducts = parseInt(this.getAttribute("data-max-products")) || 0;
            this.modelLink = null;
            this.modelName = null;
            this.useInsiderSmartRecommenderId = null;
            this.statsigStableId = null;
            this.allocatedExperiment = null;
            this.updateTimeout = 0;
            this.isGateEnabled = this.getAttribute("data-is-gate-enabled") === "true"; //TODO: pegar via parametro
            this.REQUEST_TIMEOUT_MS = 4500;
            this.modelManager = new ModelManager();
            this.objExperimentInfos = {
                stable_id: this.statsigStableId,
                gate: this.statsigGate,
                layer: this.statsigLayer,
                cart: getCartItemsIdsString(),
                customer_id: this.customerId,
                allocated_experiment: this.allocatedExperiment,
                category: "Statsig",
                component: `${EXPERIMENT.name}`,
            };
        }
        connectedCallback() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    syncDebugFlag(EXPERIMENT.name, DEBUG);
                    this.statsigManager = yield getOrCreateStatsigManager();
                    yield this.runTest();
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${EXPERIMENT.name}] StatsigManager not ready`, false, error);
                }
            });
        }
        runTest() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g;
                try {
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Iniciando execução do Dynamic Offers Collection`);
                    const stableContext = yield ((_a = getStatsigClient()) === null || _a === void 0 ? void 0 : _a.getAsyncContext());
                    this.objExperimentInfos.stable_id = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID;
                    this.statsigStableId = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID;
                    const gateOpen = yield this.statsigManager.checkGate((_b = this.statsigGate) !== null && _b !== void 0 ? _b : "");
                    const shouldPersist = gateOpen;
                    if (!shouldPersist) {
                        this.forceFallbackInSlider("closedGate");
                        Logger.warn(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Gate closed. Exiting without persisting.`, this.objExperimentInfos);
                        return;
                    }
                    // const triggers = ["stable_id"];
                    // const shouldSend = shouldSendPayload(triggers, MODEL_KEY, "every");
                    // if (!shouldSend) {
                    //   Logger.warn(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Not available to send payload. Aborting...`, triggers, this.objExperimentInfos);
                    //   return;
                    // }
                    const layer = yield this.statsigManager.getLayerParams((_c = this.statsigLayer) !== null && _c !== void 0 ? _c : "");
                    if (!layer) {
                        this.forceFallbackInSlider("layerNotFound");
                        Logger.warn(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Layer not found. Exiting.`, this.objExperimentInfos);
                        return;
                    }
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] layer`, layer);
                    this.modelLink = layer.get("modelUrl");
                    this.modelName = layer.get("modelName");
                    let persistedModelData = this.loadModelFromStorage();
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Dados do modelo persistidos anteriormente:`, persistedModelData);
                    if (!persistedModelData || (this.modelName !== "holdout" && this.modelName !== "useinsider_smart_recommender")) {
                        /**
                         * Quando o modelo for random ou v0 devemos buscar o modelo sempre, pois a resposta pode variar a cada requisição mesmo que já tenhamos algo persistido.
                         */
                        Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Buscando dados do modelo...`);
                        persistedModelData = yield this.fetchDOCollectionData();
                        Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Dados do modelo recebidos:`, persistedModelData);
                    }
                    if ((this.modelName === "holdout" || this.modelName === "useinsider_smart_recommender")) {
                        /**
                         * Mesmo que a resposta do modelo sempre seja a mesma, é importante fazer essa requisição para popular informações ao modelo,
                         * aqui não usamos async pois não é necessário aguardar resposta.
                         */
                        this.fetchDOCollectionData();
                    }
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Dados do modelo atualizado`, persistedModelData);
                    if (this.modelName === "useinsider_smart_recommender")
                        this.useInsiderSmartRecommenderId = persistedModelData.useinsider_smart_recommender_id;
                    if ((this.modelName !== "holdout" && this.modelName !== "useinsider_smart_recommender")) {
                        Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Utilizando lista de produtos do modelo`, persistedModelData);
                        const formattedProductUrlsList = (_e = (_d = persistedModelData.product_handles) === null || _d === void 0 ? void 0 : _d.map(product_url => ({ product_url: `https://insiderstore.com.br/products/${product_url}` }))) !== null && _e !== void 0 ? _e : [];
                        // const formattedProductUrlsList: ProductsUrlList = persistedModelData.product_handles?.map(product_url => ({ product_url: `http://127.0.0.1:9292/products/${product_url}` })) ?? [];
                        Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] formattedProductUrlsList:`, formattedProductUrlsList);
                        this.persistListInSlider(formattedProductUrlsList, "model");
                        return;
                    }
                    if (this.modelName === "holdout") {
                        this.hideSmartRecommenderSlider("holdout");
                        return;
                    }
                    ;
                    if (this.useInsiderSmartRecommenderId) {
                        const useInsiderData = yield this.fetchUseInsiderCollectionData(this.useInsiderSmartRecommenderId);
                        if (!useInsiderData) {
                            this.hideSmartRecommenderSlider("useInsiderNotFound");
                            Logger.warn(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] useInsiderData not found. Exiting.`, this.objExperimentInfos);
                            return;
                        }
                        const formattedProductUrlsList = (_g = (_f = useInsiderData === null || useInsiderData === void 0 ? void 0 : useInsiderData.products) === null || _f === void 0 ? void 0 : _f.map(product => ({ product_url: product.url }))) !== null && _g !== void 0 ? _g : [];
                        this.persistListInSlider(formattedProductUrlsList, "useInsider");
                        return;
                    }
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Nenhuma useInsiderSmartRecommenderId encontrada`);
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] force fallback`);
                    // this.forceFallbackInSlider("propositalFallback");
                    this.hideSmartRecommenderSlider("propositalFallback");
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${EXPERIMENT.name}] Unexpected error in runTest()`, false, error);
                }
            });
        }
        loadModelFromStorage() {
            const storage = getSafeStorage();
            let parsed = null;
            try {
                const raw = storage.getItem(this.MODEL_KEY);
                parsed = raw ? JSON.parse(raw) : null;
            }
            catch (_a) {
                parsed = null;
            }
            if (!parsed || typeof parsed !== "object")
                return null;
            return parsed;
        }
        fetchUseInsiderCollectionData(campaignId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (window && window.Insider) {
                    function waitForInsiderLoad() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return new Promise((resolve, reject) => {
                                window.Insider.eventManager.once("ins-sr:only-api-campaign:load", (event, data) => {
                                    resolve({ event, data });
                                });
                            });
                        });
                    }
                    return yield waitForInsiderLoad().then(({ _, data }) => {
                        if (data && data.campaignId === Number(campaignId))
                            return data;
                        return null;
                    });
                }
            });
        }
        fetchDOCollectionData() {
            return __awaiter(this, void 0, void 0, function* () {
                const includeFields = [
                    "customer_id",
                    "stable_id",
                    "allocated_experiment",
                    "cartItemsIds"
                ];
                const payload = buildModelRequestPayload({
                    customer_id: this.objExperimentInfos.customer_id,
                    stable_id: this.objExperimentInfos.stable_id,
                    allocated_experiment: this.objExperimentInfos.allocated_experiment,
                    cartItemsIds: this.objExperimentInfos.cart,
                }, includeFields);
                Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] payload:`, payload);
                try {
                    const data = yield this.modelManager.getModel(this.modelLink, payload, { timeout: this.REQUEST_TIMEOUT_MS }, this.MODEL_KEY, includeFields);
                    Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Dados do modelo recebidos:`, data);
                    return data;
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${EXPERIMENT.name}] Failed to fetch DOCollectionData via ModelManager`, false, error);
                    return null;
                }
            });
        }
        persistListInSlider(productsList, origin) {
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElement) {
                const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Persist Product List: ${timestamp}`);
                sliderElement.dynamicData = productsList.slice(0, this.maxProducts || productsList.length);
                sliderElement.dataset.timestamp = timestamp;
                return;
            }
            this.logError(`[DEBUG][Statsig][${EXPERIMENT.name}] Slider not founded`, true);
        }
        hideSmartRecommenderSlider(origin) {
            Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] hideSmartRecommenderSlider`);
            const sliderElementWrapper = document.querySelector(`.products-recommended-dyo`);
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElementWrapper) {
                sliderElementWrapper.style.display = "none";
                if (sliderElement) {
                    const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                    sliderElement.useDynamicRecommender = false;
                    sliderElement.status = "forceNoRender";
                    sliderElement.dataset.timestamp = timestamp;
                }
                return;
            }
        }
        forceFallbackInSlider(origin) {
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElement) {
                const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                Logger.log(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] Persist Product List: ${timestamp}`);
                sliderElement.useDynamicRecommender = false;
                sliderElement.status = "pendingForceFallback";
                sliderElement.dataset.timestamp = timestamp;
                return;
            }
            this.logError(`[DEBUG][Statsig][${EXPERIMENT.name}] Slider not founded`, true);
        }
        logError(message, showError = false, error) {
            Logger.error(EXPERIMENT.name, `[DEBUG][Statsig][${EXPERIMENT.name}] ${message}`, error);
        }
    });
